import React, { useContext } from 'react'
import { useState } from 'react'
import { useLogin } from '../hooks/useLogin';
import { Link, useNavigate } from 'react-router-dom';
import { CartContext } from '../../context/CartContext'



export default function Login() {

    const [email,setEmail] = useState('')
    const [password,setPassword] = useState('')
    const {cartItems} = useContext(CartContext)
  const navigate = useNavigate()
    const {login,error,isloading} = useLogin();

    const handleSubmit = async (e) => {
        e.preventDefault();
    const loggedIn =    await login(email,password);
    if(loggedIn) {
      !cartItems ? navigate("/"): navigate("/cart" )
    }
    }
  return (
    <form className='login' onSubmit={handleSubmit}>
        <h3>Login</h3>
        <label >Email:</label>
        <input type='email' value={email} onChange={(e) => setEmail(e.target.value)} />
        <label >Password:</label>
        <input type='password' value={password} onChange={(e) => setPassword(e.target.value)} />

        <button disabled={isloading}>Login</button>
        <h4>New user? Lets quickly <Link to="/signupuser">Signup</Link></h4>
        {error && <div className='error'>{error}</div>}
    </form>
  )
}
